import { Box, Button, debounce, Drawer, Grid, Pagination, Typography } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Event,
  FilterInfo,
  FilterProps,
  FilterSelected,
  ListItem,
  exploreListInfo,
} from "../../types/types";
import Courses from "./courses";
import { getAlllistings } from "../../services";
import { useAppSelector } from "../../assets/hooks";
// import Filters from "../courses/filters";
import { filterOptions, quickOptions } from "../../assets/menu";
import Universities from "./universitites";
import TemporaryDrawer from "../courses/filterTransition";
import CloseIcon from "@mui/icons-material/Close";
import SortMenu from "../courses/sort";
import { FilterHandler, FiltersHandler, getExploreUrl, normalizeType } from "../../assets/library";
import Images from "../../assets";
import "./explore.css";

const Explore = (props: FilterProps) => {

  const location = useLocation();
  const navigate = useNavigate();
  const searchString = useRef("");
  const page = useRef(0);
  const activeTab = useRef<string>("");
  const FilterData = useRef<FilterSelected[]>([]);
  // eslint-disable-next-line
  const [filterInfo, setFilterInfo] = useState<FilterInfo[]>([]);
  const [quickfilterInfo, setQuickFilterInfo] = useState<any[]>([]);
  const [list, setList] = useState([]);
  const currency = localStorage.getItem("currency");
  const preference = useAppSelector((state) => state.preferencesSlice);
  const [loading, setLoading] = useState(false);
  const itemsPerPage = 20;
  const currentPage = page.current;
  const [open, setopen] = useState(false);

  const listData = useRef<exploreListInfo>({
    type: "courses",
    page: 0,
    filterData: [],
    currency: "INR",
    search: "",
    totalItems: 0,
    totalPages: 1,
    appliedFilters: [],
  });

  console.log('list data',listData)
  const totalItems = listData.current.totalItems || 0;
  // console.log('total',totalItems)
  const startItem = totalItems > 0 ? (currentPage - 1) * itemsPerPage + 1 : 0;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  useEffect(() => {
    const encodedUrl = location.search.slice(1);
    const decodedUrl = window.atob(encodedUrl);
    const queryParams = new URLSearchParams(decodedUrl);
    let filterUrl = queryParams.get("FilterData");
    let activeUrl = queryParams.get("activeTab");
    let pageUrl = queryParams.get("page");
    let searchUrl = queryParams.get("search");
    setList([])
    page.current = pageUrl ? JSON.parse(pageUrl) : 1;
    FilterData.current =
      filterUrl !== undefined && filterUrl !== null
        ? JSON.parse(filterUrl)
        : [];
    activeTab.current = activeUrl ? JSON.parse(activeUrl) : "courses";
    searchString.current = searchUrl ? JSON.parse(searchUrl) : "";
    setFilterInfo(
      Object.values(filterOptions)[
      Object.keys(filterOptions).findIndex(
        (item) => item === activeTab.current
      )
      ]
    );
    setQuickFilterInfo(
      Object.values(quickOptions)[
      Object.keys(quickOptions).findIndex(
        (item) => item === activeTab.current
      )
      ]
    );
    listData.current.appliedFilters = FilterData.current;
    listData.current.type = activeTab.current;
    listData.current.search = searchString.current;
    console.log("LIst DATA",page.current,listData.current);
    let history = localStorage.getItem(activeTab.current + "ListInfo");
    listData.current.totalItems = history
      ? JSON.parse(history).totalItems
      : undefined;
    listData.current.totalPages = history
      ? JSON.parse(history).totalPages
      : undefined;
      debouncedFetchList(page.current, listData.current);
    // fetchList(page.current, listData.current);

    // Restore scroll position if it was stored
    // const savedScrollPosition = localStorage.getItem('exploreScrollPosition');
    // if (savedScrollPosition) {
    //   console.log('Restoring scroll position on page load:', parseInt(savedScrollPosition));
    //   setTimeout(() => {
    //     window.scrollTo(0, parseInt(savedScrollPosition));
    //   }, 100);
    // }

    // eslint-disable-next-line
  }, [location.search, location.pathname]); // Listen to both search params and pathname changes

  // Cleanup stored scroll position when component unmounts
  useEffect(() => {
    return () => {
      // Don't remove scroll position on unmount, keep it for when user comes back
      // localStorage.removeItem('exploreScrollPosition');
    };
  }, []);

  // Add scroll event listener to store scroll position
  useEffect(() => {
    // const handleScroll = () => {
    //   const scrollPosition = window.scrollY;
    //   if (scrollPosition > 0) {
    //     localStorage.setItem('exploreScrollPosition', scrollPosition.toString());
    //   }
    // };

    // window.addEventListener('scroll', handleScroll);
    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  const tabs = [
    {
      label: "Programs",
      value: "courses",
      Component: <Courses list={list} loading={loading}></Courses>,
    },
    {
      label: "Universities",
      value: "universities",
      Component: <Universities list={list} loading={loading}></Universities>,
    },
  ];

  const eventHandler = (event: Event) => {
    let url = '';

    switch (event.name) {
      case "tabSelected":
        let exploreHistory = localStorage.getItem(
          event.data.value + "ListInfo"
        );
        url = `activeTab=${JSON.stringify(
          event.data.value
        )}&FilterData=${JSON.stringify(
          exploreHistory ? JSON.parse(exploreHistory).appliedFilters : []
        )}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`;
        navigate(`/explore?${window.btoa(url)}`);
        break;

      case "filterUpdated":
        url = `activeTab=${JSON.stringify(
          activeTab.current
        )}&FilterData=${encodeURIComponent(JSON.stringify(event.data))}&page=${JSON.stringify(
          1
        )}&search=${JSON.stringify("")}`;
        navigate(`/explore?${window.btoa(url)}`);

        break;

      case "nextPage":
        url = `activeTab=${JSON.stringify(
          activeTab.current
        )}&FilterData=${JSON.stringify(
          FilterData.current
        )}&page=${JSON.stringify(page.current + 1)}&search=${JSON.stringify(
          searchString.current
        )}`;
        navigate(`/explore?${window.btoa(url)}`);

        break;

      case "pageChange":
      console.log("Page Change",event.data)  
      url = `activeTab=${JSON.stringify(
          activeTab.current
        )}&FilterData=${encodeURIComponent(JSON.stringify(
          FilterData.current
        ))}&page=${JSON.stringify(event.data)}&search=${JSON.stringify(
          searchString.current
        )}`;
        navigate(`/explore?${window.btoa(url)}`);
        break;

      case "search":
        url = `activeTab=${JSON.stringify(
          activeTab.current
        )}&FilterData=${JSON.stringify(
          FilterData.current
        )}&page=${JSON.stringify(1)}&search=${JSON.stringify(event.data)}`;
        navigate(`/explore?${window.btoa(url)}`);

        break;

      case "previousPage":
        url = `activeTab=${JSON.stringify(
          activeTab.current
        )}&FilterData=${JSON.stringify(
          FilterData.current
        )}&page=${JSON.stringify(page.current - 1)}&search=${JSON.stringify(
          searchString.current
        )}`;
        navigate(`/explore?${window.btoa(url)}`);
        break;
    }
  };

  const isRequestInProgress = useRef(false); 
  const queuedUpdate = useRef(false);
  const abortController = useRef<AbortController | null>(null);
  const cache = useRef<Map<string, any>>(new Map());
  
  // Clear cache when component unmounts
  useEffect(() => {
    const currentCache = cache.current;
    return () => {
      currentCache.clear();
    };
  }, []); 

  const fetchList = useCallback(
    async (requiredPage: number, listInfo: exploreListInfo) => {
      // Cancel previous request if it exists
      if (abortController.current) {
        abortController.current.abort();
      }
      if (isRequestInProgress.current) {
        queuedUpdate.current = true; 
        return;
      }
      isRequestInProgress.current = true;
      abortController.current = new AbortController(); 
      if (requiredPage === 1) {
        listInfo.totalPages = 1;
      }
      if (listInfo.totalPages && requiredPage <= listInfo.totalPages) {
        console.log("Fetching");
        let filters = listInfo?.appliedFilters?.map((filter: any) => ({
          ...filter,
          data: filter?.data.map((item: any) => item?.value),
        }));
        
        // Create cache key
        const cacheKey = JSON.stringify({
          type: listInfo.type,
          page: requiredPage,
          filters: filters,
          search: listInfo.search,
          currency: preference.data?.budget || currency || "INR"
        });
        console.log("Cache",cacheKey,cache.current);
        // Check cache first
        
        if (cache.current.has(cacheKey)) {
          console.log('Using cached data for:', cacheKey);
          const cachedData = cache.current.get(cacheKey);
          setList(cachedData.list);
          listInfo.totalItems = cachedData.totalItems;
          listInfo.totalPages = cachedData.totalPages;
          setLoading(false);
          isRequestInProgress.current = false;
          return;
        }
        setLoading(true);
        try {

          const response = await getAlllistings(listInfo.type, {
            page: requiredPage,
            currency:"INR",
            filterData: listInfo.search
              ? [...filters, { type: "name", data: [listInfo.search] }]
              : filters,
          }, abortController.current.signal);
          if (response.success) {
            listInfo.totalItems = response.data.totalItems;
            listInfo.totalPages = response.data.totalPages;
            localStorage.setItem(
              listInfo.type + "ListInfo",
              JSON.stringify(listInfo)
            );
            setList(response.data.list);
            
            // Cache the response
            cache.current.set(cacheKey, {
              list: response.data.list,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            });
            
            console.log('Updated list with', response.data.list.length, 'items');
          }
        } catch (err: any) {
          if (err.name === 'AbortError') {
            console.log('Request was aborted');
            return;
          }
          console.error('API Error:', err);
        } finally {
          setLoading(false);
          isRequestInProgress.current = false; 
          if (queuedUpdate.current) {
            queuedUpdate.current = false;
            fetchList(page.current, listData.current);
          }
        }
      }
    },
    [preference, currency]
  );
  
// eslint-disable-next-line
  const debouncedFetchList = useCallback(
    debounce((requiredPage, listInfo) => {
      fetchList(requiredPage, listInfo);
    }, 100), // Reduced from 200ms to 100ms for faster response
    [fetchList]
  );

  console.log("Quick Filkters",quickfilterInfo,quickOptions);

  return (
    <Box sx={{
      display: "flex",
      justifyContent: "center", alignItems: "center",
      width: "100%", marginTop: "5rem"
    }}>
      <div style={{
        maxWidth: "1440px",
        width: "100%",
        marginBottom: "4rem",
        // overflowY: "scroll"
      }}>
        <Grid container spacing={1}>
          <Grid item lg={2.5} className="explore-filters-sidebar">
            <Box sx={{
              boxShadow: "0px 4px 16px 0px #00000040",
              width: "90%",
              mt: 2,
              borderRadius: "1rem",
              height: "calc(100vh - 200px)",
              overflowY: "auto",
              overflowX: "hidden",
              // Hide scrollbar for all browsers
              '::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}>
              <TemporaryDrawer
                appliedFilters={FilterData.current}
                setAppliedFilter={(data: FilterSelected[]) => {
                  eventHandler({ name: "filterUpdated", data: data });
                }}
              // options={filterInfo}
              />
            </Box>
          </Grid>
          <Grid item xs={12} lg={9.5} sx={{
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            overflowX: "hidden",
            // Hide scrollbar for all browsers
            '::-webkit-scrollbar': { display: 'none' },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}>
            <Grid container sx={{ display: "flex", alignItems: "center" }}>
              <Grid item xs={9} sm={10} lg={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {startItem > 0 ?
                  <Typography sx={{ display: "flex", gap: "0.5rem", pl: 2 }}>
                    <span style={{ color: "#495052", fontWeight: "600" }}>
                      {startItem}-{endItem}
                    </span>
                    out of
                    <span style={{ color: "#495052", fontWeight: "600" }}>
                      {totalItems}
                    </span>
                    results
                  </Typography>
                  : <Typography sx={{ display: "flex", gap: "0.5rem", pl: 2 }}>
                    <span style={{ color: "#495052", fontWeight: "600" }}>
                      {totalItems}
                    </span>
                    results
                  </Typography>}
                {
                  activeTab.current === "courses" &&
                  <SortMenu setList={setList} list={list} />
                }
              </Grid>
              <Grid item xs={3} sm={2} className="explore-mobile-filters">
                <Button
                  onClick={() => setopen(true)}
                  sx={{
                    display: "flex",
                    gap: "6px",
                    color: "#000",
                    fontWeight: "500",
                    textTransform: "none",
                    mb: 1
                  }}
                >
                  <img src={Images.filterIcon} alt="icon" style={{ width: "20px" }} /> Filters
                </Button>
              </Grid>

            </Grid>
            <Box
              sx={{
                display: "flex", 
                flexWrap: "nowrap", 
                alignItems: "center", 
                overflowX: "auto",
                paddingLeft: "1rem",
                scrollbarWidth:"none",
              mb:2
              }}
            >
              {quickfilterInfo?.map((item, i) => (
                <FilterContainer
                  key={i}
                  data={item}
                  appliedFilter={
                    FilterData.current?.find((item2) => item2.type === item.type) || {
                      type: item.type,
                      data: [],
                    }
                  }
                  onSelection={FilterHandler}
                  normalizeType={normalizeType}
                  appliedFilters={FilterData.current}
                />
              ))}
            </Box>

            <Box>
              {tabs.find((item) => item.value === activeTab.current)?.Component}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", my: 2 }}>
              {startItem > 0 && <Pagination
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 1,
                  "& .MuiPaginationItem-root.Mui-selected": {
                    background: "#F48438 !important",
                    color: "#fff",
                    borderRadius: "5px",
                    height: "28px",
                    minWidth: "28px !important",
                    p: "0 !important"
                  },
                }}
                count={listData.current.totalPages}
                page={page.current}
                onChange={(event, value) =>
                  eventHandler({ name: "pageChange", data: value })
                }
                showFirstButton
                showLastButton
              />}
            </Box>
          </Grid>
          {open ? (
            ["right"].map((anchor: any) => (
              <React.Fragment key={anchor}>
                <Drawer anchor={anchor} open={open} onClose={() => setopen(!open)} className="explore-mobile-filters" sx={{
                  "& .MuiPaper-root": {
                    width: "60%",
                  }
                }}>
                  <Box>
                    <CloseIcon sx={{ float: "right", m: 1, cursor: "pointer" }} onClick={() => setopen(!open)} />
                  </Box>
                  <TemporaryDrawer
                    appliedFilters={FilterData.current}
                    setAppliedFilter={(data: FilterSelected[]) => {
                      eventHandler({ name: "filterUpdated", data: data });
                    }}
                  // options={filterInfo}
                  />
                </Drawer>
              </React.Fragment>
            ))
          )
            : null}

        </Grid>
      </div>
    </Box>
  );
};


const FilterContainer = (props: {
  data: FilterInfo;
  initialValue?: FilterSelected | undefined;
  onSelection: any;
  normalizeType: any;
  appliedFilter: any;
  appliedFilters: FilterSelected[] | undefined;
}) => {
  return (
    <>
      <DefaultContainer
        appliedFilter={props?.appliedFilter}
        data={props?.data}
        initialValue={
          props?.initialValue
            ? props?.initialValue
            : { type: props?.data?.type, data: [] }
        }
        onSelection={props?.onSelection}
        normalizeType={props?.normalizeType}
      />
    </>
  );
};


const DefaultContainer = (props: {
  data: FilterInfo;
  initialValue: FilterSelected | undefined;
  onSelection: any;
  normalizeType: any;
  appliedFilter: FilterSelected;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const onSelection = (val: ListItem) => {
    console.log('Hello',val)
    let filterData = FilterHandler({
      data: val,
      filterInfo: props.data,
      filter: props.appliedFilter,
    });
    const encodedUrl = location.search.slice(1);
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = "";
    }

    const urlParams = new URLSearchParams(decodedUrl);
    let FilterUrl = urlParams.get("FilterData");
    let allFilters = FiltersHandler(
      filterData,
      FilterUrl ? JSON.parse(FilterUrl) : []
    );
    navigate(getExploreUrl("filterData", allFilters));
  };

  return (
    <>
      {props?.data?.options?.map((item, i) => (
        <Button
        key={i}
          sx={{
            border: props.appliedFilter?.data.find(
              (data) =>
                data.value === item.value
            )
              ? "1px solid var(--3-primary-teal, #70A6B2)" : "1px solid #70A6B2",
            backgroundColor: props.appliedFilter?.data.find(
              (data) =>
                data.value === item.value
            )
              ? "#70A6B2"
              : "transparent",
            color:props.appliedFilter?.data.find(
              (data) =>
                data.value === item.value
            )? "#ffff": "#495052",
            textTransform: "none",
            marginRight: "0.5rem",
            fontSize: "13px",
            borderRadius: "8px",
            "&:hover": {
              background: "#70A6B2",
              color:"#ffff"
            }, width: "auto",
            flexShrink:0
          }}
          onClick={(e) => onSelection(item)}
        >
          {props.normalizeType(props.data.label)}
        </Button>
      ))}
    </>
  );
};

export default Explore;


// import { Box, Button, Drawer, Grid, Pagination, Typography } from "@mui/material";
// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Event,
//   FilterInfo,
//   FilterProps,
//   FilterSelected,
//   exploreListInfo,
// } from "../../types/types";
// import Courses from "./courses";
// import { getAlllistings } from "../../services";
// // import { useAppDispatch, useAppSelector } from "../../assets/hooks";
// // import Filters from "../courses/filters";
// import { filterOptions } from "../../assets/menu";
// import Universities from "./universitites";
// // import TemporaryDrawer from "../courses/filterTransition";
// import FilterAltIcon from '@mui/icons-material/FilterAlt';
// import CloseIcon from "@mui/icons-material/Close";
// import TemporaryDrawer from "./filterTransition";
// // import { setPopup } from "src/store/Slices/popupSlice";

// const Explore = (props: FilterProps) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   // const queryParams = new URLSearchParams(location.search);
//   const auth = localStorage.getItem("_auth")
//   const searchString = useRef("");
//   const page = useRef(0);
//   const activeTab = useRef<string>("");
//   const FilterData = useRef<FilterSelected[]>([]);
//   const [filterInfo, setFilterInfo] = useState<FilterInfo[]>([]);
//   const [list, setList] = useState([]);
//   // const preference = useAppSelector((state) => state.preferences);
//   const [loading, setLoading] = useState(false);
//   //const listInfo:any = localStorage.getItem("ListInfo")
//   const listData = useRef<exploreListInfo>({
//     type: "courses",
//     page: 0,
//     filterData: [],
//     currency: "INR",
//     search: "",
//     totalItems: undefined,
//     totalPages: 1,
//     appliedFilters: [],
//   });
//   useEffect(() => {
//     const encodedUrl = location.search.slice(1);
//     const decodedUrl = window.atob(encodedUrl);
//     const queryParams = new URLSearchParams(decodedUrl);
//     let filterUrl = queryParams.get("FilterData");
//     let activeUrl = queryParams.get("activeTab");
//     let pageUrl = queryParams.get("page");
//     let searchUrl = queryParams.get("search");
//     page.current = pageUrl ? JSON.parse(pageUrl) : 1;
//     FilterData.current =
//       filterUrl !== undefined && filterUrl !== null
//         ? JSON.parse(filterUrl)
//         : [];
//     activeTab.current = activeUrl ? JSON.parse(activeUrl) : "courses";
//     searchString.current = searchUrl ? JSON.parse(searchUrl) : "";
//     setFilterInfo(
//       Object.values(filterOptions)[
//       Object.keys(filterOptions).findIndex(
//         (item) => item === activeTab.current
//       )
//       ]
//     );
//     listData.current.appliedFilters = FilterData.current;
//     listData.current.type = activeTab.current;
//     listData.current.search = searchString.current;

//     let history = localStorage.getItem(activeTab.current + "ListInfo");
//     listData.current.totalItems = history
//       ? JSON.parse(history).totalItems
//       : undefined;
//     listData.current.totalPages = history
//       ? JSON.parse(history).totalPages
//       : undefined;

//     fetchList(page.current, listData.current);

//     // eslint-disable-next-line
//   }, [location]);
//   // console.log(activeTab,listData,"listinfo")

//   const tabs = [
//     {
//       label: "Programs",
//       value: "courses",
//       Component: <Courses list={list} loading={loading}></Courses>,
//     },
//     {
//       label: "Universities",
//       value: "universities",
//       Component: <Universities list={list} loading={loading}></Universities>,
//     },
//   ];

//   const eventHandler = (event: Event) => {
//     let url = '';

//     switch (event.name) {
//       case "tabSelected":
//         let exploreHistory = localStorage.getItem(
//           event.data.value + "ListInfo"
//         );
//         url = `activeTab=${JSON.stringify(
//           event.data.value
//         )}&FilterData=${JSON.stringify(
//           exploreHistory ? JSON.parse(exploreHistory).appliedFilters : []
//         )}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`;
//         navigate(`/explore?${window.btoa(url)}`);
//         break;

//       case "filterUpdated":
//         url = `activeTab=${JSON.stringify(
//           activeTab.current
//         )}&FilterData=${encodeURIComponent(JSON.stringify(event.data))}&page=${JSON.stringify(
//           1
//         )}&search=${JSON.stringify("")}`;
//         navigate(`/explore?${window.btoa(url)}`);

//         break;

//       case "nextPage":
//         url = `activeTab=${JSON.stringify(
//           activeTab.current
//         )}&FilterData=${JSON.stringify(
//           FilterData.current
//         )}&page=${JSON.stringify(page.current + 1)}&search=${JSON.stringify(
//           searchString.current
//         )}`;
//         navigate(`/explore?${window.btoa(url)}`);

//         break;

//       case "pageChange":
//         console.log(event.data)
//         if (event.data > 2) {
//           if (auth) {
//             url = `activeTab=${JSON.stringify(
//               activeTab.current
//             )}&FilterData=${encodeURIComponent(JSON.stringify(
//               FilterData.current
//             ))}&page=${JSON.stringify(event.data)}&search=${JSON.stringify(
//               searchString.current
//             )}`;
//             navigate(`/explore?${window.btoa(url)}`);
//           } else {

//           }
//         }else{
//           url = `activeTab=${JSON.stringify(
//             activeTab.current
//           )}&FilterData=${encodeURIComponent(JSON.stringify(
//             FilterData.current
//           ))}&page=${JSON.stringify(event.data)}&search=${JSON.stringify(
//             searchString.current
//           )}`;
//           navigate(`/explore?${window.btoa(url)}`);
//         }


//         break;

//       case "search":
//         url = `activeTab=${JSON.stringify(
//           activeTab.current
//         )}&FilterData=${JSON.stringify(
//           FilterData.current
//         )}&page=${JSON.stringify(1)}&search=${JSON.stringify(event.data)}`;
//         navigate(`/explore?${window.btoa(url)}`);

//         break;

//       case "previousPage":
//         url = `activeTab=${JSON.stringify(
//           activeTab.current
//         )}&FilterData=${JSON.stringify(
//           FilterData.current
//         )}&page=${JSON.stringify(page.current - 1)}&search=${JSON.stringify(
//           searchString.current
//         )}`;
//         navigate(`/explore?${window.btoa(url)}`);
//         break;
//     }
//   };


//   const fetchList = async (requiredPage: number, listInfo: exploreListInfo) => {
//     //console.log("filters",listInfo.appliedFilters);
//     if (requiredPage === 1) {
//       listInfo.totalPages = 1;
//     }
//     if (listInfo.totalPages && requiredPage <= listInfo.totalPages) {
//       let filters = listInfo?.appliedFilters?.map((filter: any) => ({
//         ...filter,
//         data: filter?.data.map((item: any) => item?.value),
//       }));
//       setLoading(true);
//       const response = await getAlllistings(listInfo.type, {
//         page: requiredPage,
//         currency:"INR",
//         filterData: listInfo.search
//           ? [...filters, { type: "name", data: [listInfo.search] }]
//           : filters,
//       });
//       if (response.success) {
//         listInfo.totalItems = response.data.totalItems;
//         listInfo.totalPages = response.data.totalPages;
//         localStorage.setItem(
//           listInfo.type + "ListInfo",
//           JSON.stringify(listInfo)
//         );
//         // console.log("local store",localStorage.getItem("ListInfo"))
//         setList(response.data.list);
//       }
//       setLoading(false);
//     }
//   };


//   // console.log(filterInfo)
//   const itemsPerPage = 20;
//   const currentPage = page.current; // current page number (1-based index)
//   const totalItems = listData.current.totalItems || 0;

//   const startItem = (currentPage - 1) * itemsPerPage + 1;
//   const endItem = Math.min(currentPage * itemsPerPage, totalItems);
//   const [open, setopen] = useState(false);

//   return (
//     <Box sx={{
//       display: "flex",
//       justifyContent: "center", alignItems: "center",
//       // minHeight:{md:"680px"},
//       //       maxHeight:{md:"750px"},
//       width: "100%",
//     }}>
//       <div style={{
//         maxWidth: "1440px",
//         width: "100%",
//         height: "100%", overflowY: "scroll"
//       }}>
//         <Grid container spacing={1}>
//           <Grid item lg={2.5} sx={{ display: { xs: "none", lg: "block" }, paddingLeft: "16px !important" }}>
//             <Box sx={{
//               boxShadow: "0px 4px 16px 0px #00000040",
//               width: "90%",
//               mt: 2,
//               borderRadius: "1rem"
//             }}>
//               <TemporaryDrawer
//                 open={open}
//                 setOpen={setopen}
//                 appliedFilters={FilterData.current}
//                 setAppliedFilter={(data: FilterSelected[]) => {
//                   eventHandler({ name: "filterUpdated", data: data });
//                 }}
//                 options={filterInfo}
//               />
//               {/* <Filters
//             options={filterInfo}
//             appliedFilters={FilterData.current}
//             setAppliedFilter={(data: FilterSelected[]) => {
//               eventHandler({ name: "filterUpdated", data: data });
//             }}
//           /> */}
//             </Box>
//           </Grid>

//           <Grid item xs={12} lg={9.5} sx={{}}>
//             <Tabs 
//           tabs={tabs}
//           activeTab={activeTab.current}
//           handler={eventHandler}
//         />
//             <Grid container>
//               <Grid item xs={8} lg={12}>
//                 <Typography sx={{ display: "flex", gap: "0.5rem", pl: 2 }}>
//                   <span style={{ color: "#FFA89C", fontWeight: "500" }}>
//                     {startItem}-{endItem}
//                   </span>
//                   out of
//                   <span style={{ color: "#FFA89C", fontWeight: "500" }}>
//                     {totalItems}
//                   </span>
//                   results
//                 </Typography>
//               </Grid>
//               <Grid item xs={4} sx={{ display: { lg: "none" } }}>
//                 <Button
//                   onClick={() => setopen(true)}
//                   sx={{
//                     display: "flex",
//                     gap: "6px",
//                     color: "#000",
//                     fontWeight: "500",
//                     textTransform: "none",
//                     mb: 1
//                   }}
//                 >
//                   <FilterAltIcon sx={{ fontSize: "1.2rem" }} />  More filters
//                 </Button>
//               </Grid>
//             </Grid>
//             <Box>
//               {tabs.find((item) => item.value === activeTab.current)?.Component}
//             </Box>
//             <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", my: 2 }}>
//               {/* {page.current > 1 ? (
//             <Button
//               onClick={() => eventHandler({ name: "previousPage" })}
//               sx={[
//                 globalButton,
//                 { fontSize: "12px", width: "150px", borderRadius: "10px" },
//               ]}
//             >
//               <EastIcon
//                 sx={{ mr: 1, transform: "rotate(180deg)", fontSize: "1rem" }}
//               /> Previous Page
//             </Button>
//           ) : null}
//           {listData.current.totalPages && listData.current.totalPages > 1 ? 
//            <Button
//            sx={{
//              border: "2px solid #3B3F76",
//              color: "#3B3F76",
//              fontWeight: "500",
//              fontSize: "12px",
//              textTransform: "none",
//              borderRadius: "10px",
//              width: "150px",
//              "&:hover": {
//                color: "#3B3F76",
//              },
//            }}
//            onClick={() => eventHandler({ name: "nextPage" })}
//          >
//            Next Page <EastIcon sx={{ ml: 1, fontSize: "1rem" }} />
//          </Button> : null} */}
//               <Pagination
//                 sx={{
//                   display: "flex",
//                   justifyContent: "center",
//                   mt: 1,
//                   "& .MuiPaginationItem-root.Mui-selected": {
//                     background: "#3B3F76 !important",
//                     color: "#fff",
//                   },
//                 }}
//                 count={listData.current.totalPages}
//                 page={page.current}
//                 // renderItem={(item) => {
//                 //   if (item.page === 1 || item.page === 2 || item.page === 3 || item.page === 4 || item.page === listData.current.totalPages) {
//                 //     return <PaginationItem {...item} />;
//                 //   }
//                 //   if (item.page === 5) {
//                 //     return <span>...</span>;
//                 //   }
//                 //   return null;
//                 // }}
//                 onChange={(event, value) =>
//                   eventHandler({ name: "pageChange", data: value })
//                 }
//                 showFirstButton
//                 showLastButton
//               />
//             </Box>
//           </Grid>

//           {open ? (
//             ["right"].map((anchor: any) => (
//               <React.Fragment key={anchor}>
//                 <Drawer anchor={anchor} open={open} onClose={() => setopen(!open)} sx={{
//                   "& .MuiPaper-root": {
//                     width: "50%"
//                   }
//                 }}>
//                   <Box>
//                     <CloseIcon sx={{ float: "right", m: 1, cursor: "pointer" }} onClick={() => setopen(!open)} />
//                   </Box>
//                   <TemporaryDrawer
//                     // open={open}
//                     // setOpen={setopen}
//                     appliedFilters={FilterData.current}
//                     setAppliedFilter={(data: FilterSelected[]) => {
//                       eventHandler({ name: "filterUpdated", data: data });
//                     }}
//                     options={filterInfo}
//                   />
//                 </Drawer>
//               </React.Fragment>
//             ))
//           )
//             : null}

//         </Grid>
//       </div>
//     </Box>
//   );
// };

// const Tabs = (props: any) => {
//   return (
//     <div>
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           // width: "100%",
//           m: 1,
//           mb: 2,
//           gap: "30px",
//         }}
//       >
//         {props.tabs.map((item: any) => (
//           <Button
//             onClick={() => props.handler({ name: "tabSelected", data: item })}
//             sx={{
//               borderBottom:
//                 item.value === props.activeTab ? "2px solid #3B3F76" : 0,
//               color: item.value === props.activeTab ? "#3B3F76" : "#3B3F764D",
//               borderRadius: 0,
//               textTransform: "none",
//               fontSize: "1rem",
//               fontWeight: "600",
//             }}
//           >
//             {item.label}
//           </Button>
//         ))}
//       </Box>
//     </div>
//   );
// };
// export default Explore;
